import { IEntity } from '../interfaces/entity';
import { Subject } from './subject';
import { Url } from './url';

export interface ISubjectUrlList{
  items: SubjectUrl[];
  totalCount: number;
}

export class SubjectUrl implements IEntity {
  id: number;
  uid: string;
  subjectId: number;
  urlId: number;
  subject: Subject;
  url: Url;
  attachmentType: number;

  constructor(subjectUrl?){
    subjectUrl = subjectUrl || {};
    this.id = subjectUrl.id;
    this.uid = subjectUrl.uid;
    this.subjectId = subjectUrl.subjectId;
    this.urlId = subjectUrl.urlId;
    this.subject = subjectUrl.subject;
    this.url = subjectUrl.url;
    this.attachmentType = subjectUrl.attachmentType;
  }
}
